import React from 'react';
import Header from '../../components/ui/Header';
import HeroSection from './components/HeroSection';
import VisionMissionSection from './components/VisionMissionSection';
import ApproachSection from './components/ApproachSection';
import AchievementsSection from './components/AchievementsSection';
import TimelineSection from './components/TimelineSection';
import TestimonialsSection from './components/TestimonialsSection';
import ContactSection from './components/ContactSection';

const AboutUs = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main>
        <HeroSection />
        <VisionMissionSection />
        <ApproachSection />
        <AchievementsSection />
        <TimelineSection />
        <TestimonialsSection />
        <ContactSection />
      </main>
    </div>
  );
};

export default AboutUs;